const animationFunctions = () => {
    $(window).trigger('scroll');    

    fadeInOnScroll();

    if ( $('.c-awards').length ) {
        gsap.utils.toArray('.c-awards').forEach((item) => {
            const trigger = item.querySelector('.c-awards__row');
            const items = item.querySelectorAll('.c-awards__award');

            gsap.to(items, {
                scrollTrigger: {
                    trigger: trigger,
                    start: 'top bottom',
                },
                y: 0, autoAlpha: 1, duration: 0.6, stagger: 0.2
            });            
        });
    }

    if ( $('.features__item').length ) {
        gsap.utils.toArray('.features__item').forEach((item, index) => {
            gsap.to(item, {
                scrollTrigger: {
                    trigger: item,
                    start: 'center bottom'
                },
                y: 0, autoAlpha: 1, duration: 0.6, delay: index * 0.15
            })
        });
    }

    if ( $('.hero-section').length ) {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.hero-section',
                start: () => {
                    const headerHeight = $('.c-header').outerHeight();
                    return 'top top+=' + headerHeight;
                },
                end: 'bottom top',
                scrub: true
            }
        });
        
        gsap.utils.toArray('.js-parallax').forEach(item => {
            const depth = item.dataset.depth;
            const movement = -(item.offsetHeight * depth)
            tl.to(item, {y: movement, ease: 'none'}, 0)
        });        
    }
};

const isBrowserIE = () => {
    var ua = window.navigator.userAgent; // Check the userAgent property of the window.navigator object
    var msie = ua.indexOf('MSIE '); // IE 10 or older
    var trident = ua.indexOf('Trident/'); //IE 11
      
    if (msie > 0 || trident > 0) { // If IE 11 or worse
        return true;
    }
  
    return false;
}

const fadeInOnScroll = () => {
    // Check if internet explorer or mobile and turn off scrolling animations if so.
    if (isBrowserIE()) {
        $('.js-hidden').addClass('js-visible');
      // return;
    }

    const hiddenSections = document.querySelectorAll('.js-hidden');

    function fadeInVisible() {
        hiddenSections.forEach(function(s,i) {
            if (s.getBoundingClientRect().top <= window.innerHeight - 60) {
                s.classList.add('js-visible');
            }
        });
    }
  
    $(window).on('scroll resize load', function(e) {
        fadeInVisible();
    });
}
